import React from 'react'
import PropTypes from 'prop-types'
import 'material-icons/iconfont/outlined.css'

import colors from '@settings/styleSettings'
import Text from './Text'

const styles = {
  inputContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: 4,
    width: '100%',
    borderRadius: 12,
    backgroundColor: colors.grayBackground,
    border: `1px solid ${colors.softGray}`,
  },
  text: {
    fontSize: 16,
    color: colors.strongGray,
    marginLeft: 8,
  },
  title: {
    fontSize: 16,
    color: colors.strongGray,
    fontWeight: 'CircularStd-Bold',
  },
  required: {
    color: colors.strongRed,
    fontSize: 16,
  },
  labelContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 0,
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    width: '100%',
  },
  icon: {
    color: colors.strongGray,
    marginRight: 8,
  },

}

const TextWithCard = ({
  text, title
}) => (
  <div style={styles.container}>
    <div style={styles.labelContainer}>
      <Text style={styles.title}>{title}</Text>
      <Text style={styles.required}>*</Text>
    </div>
    <div style={styles.inputContainer}>
      <Text style={styles.text}>
        {text}
      </Text>
      <div style={styles.icon} className="material-symbols-outlined">block</div>
    </div>
  </div>
)

TextWithCard.propTypes = {
  text: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
}

export default TextWithCard
